import { makeStyles, createMuiTheme } from '../MaterialUI/index';
export const useStyles = makeStyles((Theme) => ({
  formControl: {
    minWidth: '100%',
  },
  selectEmpty: {
    marginTop: Theme.spacing(2),
  },
  root: {
    height: '100vh',
    width: '100%',
  },
  margin: {
    margin: 'auto',
    width: '100%',
  },
  cardTitle: {
    backgroundColor: '#4A5259',
    height: '96px',
    fontSize: '24px',
    fontWeight: '600',
    position: 'absolute',
    width: 'inherit',
    borderRadius: '8px 8px 0 0',
    zIndex: '4',
  },
  card: {
    width: '490px',
    height: '80%',
    margin: 'auto',
    display: 'flex',
    borderRadius: '14px/14px',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.06), 0 4px 8px 0 rgba(0, 0, 0, 0.06)',
    overflowY: 'scroll',
    '@media (min-width:786px) and (max-width:1024px)': {
      width: '55%',
    },
    '@media (min-width:1740px)': {
      height: '80%',
    },
    '@media (max-width:786px) and (min-width:320px)': {
      width: '90%',
      height: '90%',
    },
  },
  leftSideContact: {
    flex: '1',
  },
  mainSideContact: {
    display: 'flex',
    height: '100%',
  },

  paper: {
    margin: '96px 32px 32px',
  },

  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: '0',
  },
  Label1: {
    // marginTop: '-43px',
    textAlign: 'left',
    color: '#4A5259',
    fontWeight: 500,
    fontSize: '0.875rem',
    marginBottom: '8px',
  },
  Label2: {
    // marginLeft: '-16px',
    textAlign: 'left',
    color: '#4A5259',
    fontWeight: 500,
    marginBottom: '8px',
    fontSize: '0.875rem',
    // marginTop: '-30px',
  },
  ContactInput: {
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#3f69ff',
    },
    '& .MuiAutocomplete-root .MuiOutlinedInput-root': {
      padding: '3px',
    },
    marginTop: '16px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  selectOption: {
    '&:after': {
      backgroundColor: '#e8e8e8',
    },
  },
  CloseProduct: {
    position: 'absolute',
    right: '20px',
    top: '20px',
    cursor: 'pointer',
    color: '#fff',
  },
  submit: {
    marginBottom: '16px',
    color: 'white',
    borderRadius: '8px/8px',
    backgroundColor: '#f4263e',
    height: '40px',
  },
}));

export const Theme = createMuiTheme({
  overrides: {
    MuiPaper: {
      outlined: {
        border: 'none !important',
      },
    },
    MuiInputLabel: {
      root: {
        '&$focused': {
          color: '#4A5259',
        },
      },
    },
    MuiInput: {
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#3f69ff',
      },
      underline: {
        '&:before': {
          borderBottom: 'none',
        },
        '&:after': {
          borderBottom: 'none',
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        marginBottom: '0',
      },
    },
    MuiSelect: {
      select: {
        MuiSelect: {
          select: {
            marginBottom: '0px',
          },
        },
      },
    },
    MuiFormControl: {
      root: {
        width: '100%',
      },
      marginNormal: {
        marginRight: '0',
        width: '-webkit-fill-available',
        marginTop: '0px',
        marginBottom: '0px',
      },
    },
    MuiFormHelperText: {
      contained: {
        marginLeft: '0',
      },
    },
    MuiTabs: {
      flexContainer: {
        display: 'inline-flex',
      },
    },
  },
});
